var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ac-wizard-builder',{attrs:{"rule_JSON":_vm.ruleJson,"prefill_data":_vm.prefillData,"workflow_JSON":_vm.workflowJson,"avail_tabs":_vm.availObj,"trigger_JSON":_vm.triggerJson},on:{"outputJson":_vm.getOutput}})}
var staticRenderFns = []

export { render, staticRenderFns }